export function getFacilitySecurityUnlinkPath(facilityId: string, securityId: string): string {
  return `/api/crm/facilities/${facilityId}/securities/${securityId}/unlink`;
}
